import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import { API_BASE_URL, RECAPTCHA_SITE_KEY } from "@utils/constant";
import { SubmitHandler, useForm } from "react-hook-form";
import { Fade } from "react-awesome-reveal";
import ThankYou from "@pages/contact/parts/thank-you";
import { triggerEachFormTracker } from "@utils/helper";
import { FloatingLabel, Form } from "react-bootstrap";
import { COUNTRIES } from "@utils/contries";

// const brands = [
//   { src: "/assets/images/kwikcheckoutcod/lakme.png", alt: "Lakme" },
//   { src: "/assets/images/kwikcheckoutcod/boat.png", alt: "Boat" },
//   { src: "/assets/images/kwikcheckoutcod/limeroad.png", alt: "Limeroad" },
//   { src: "/assets/images/kwikcheckoutcod/neemans.png", alt: "Neemans" },
//   { src: "/assets/images/kwikcheckoutcod/firebolt.png", alt: "Firebolt" },
//   { src: "/assets/images/kwikcheckoutcod/lenskart.png", alt: "Lenskart" },
//   { src: "/assets/images/kwikcheckoutcod/itc.png", alt: "ITC" },
//   { src: "/assets/images/kwikcheckoutcod/mamaearth.png", alt: "MamaEarth" },
// ];

const platformOptions = [
  {
    name: "<500",
  },
  {
    name: "500-1000",
  },
  {
    name: "1000+",
  },
];

const SectionOne: React.FC<any> = () => {
  const params = new URLSearchParams(window.location.search);
  // export const SectionOne = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const recaptchaRef = React.useRef<ReCAPTCHA>();
  const { register } = useForm({});

  const [formData, setFormData] = useState({
    name: "",
    country: "",
    mobile: "",
    email: "",
    brand_url: "",
    // monthly_order: "",
    g_recaptcha_token: "",
    emailMarketing: false,
    whatsappMarketing: false,
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const { handleSubmit, getValues } = useForm({});

  // const { data, params } = props;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    // Allow only + and digits in mobile
    if (name === "mobile" && /[^\d+]/.test(value)) return;

    if (name === "monthly_order") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        sub_platform: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Clear error for field
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors: typeof errors = {};
    if (!formData.name.trim()) newErrors.name = "Full name is required.";
    if (!formData.mobile.trim()) newErrors.mobile = "Phone number is required.";
    else if (!/^\+?\d{7,15}$/.test(formData.mobile.trim()))
      newErrors.mobile = "Enter a valid Phone number.";

    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim()))
      newErrors.email = "Enter a valid email id.";

    if (!formData.brand_url.trim()) {
      newErrors.brand_url = "Ecommerce Store Link is required.";
    }

    if (!formData.country.trim()) {
      newErrors.country = "Country is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleRecaptchaChange = (value) => {
    formData.g_recaptcha_token = value;
    // formData.monthly_order = getValues("monthly_order");
    // formData.sub_platform = getValues("sub_platform");
    axios
      .post(API_BASE_URL + "form/ke-international-form", formData)
      .then(function (response) {
        setSuccessMessage("Demo booked successfully!");
        triggerEachFormTracker(formData);
        setFormData({
          name: formData.name,
          country: "",
          mobile: "",
          email: "",
          brand_url: "",
          g_recaptcha_token: "",
          emailMarketing: false,
          whatsappMarketing: false,
        });
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error.response.data?.errors["product[]"]);
        setErrors(error?.response?.data?.errors);
      });
  };

  const handleRecaptchaSubmit = async () => {
    // Trigger the reCAPTCHA challenge
    recaptchaRef.current.execute();
  };

  const onSubmit: SubmitHandler<any> = async (data) => {
    // if (!data.product) {
    //   data.product = [];
    // }
    setSuccessMessage("");
    if (!validateForm()) return;

    data.source = params.get("utm_source");
    data.medium = params.get("utm_medium");
    data.campaign = params.get("utm_campaign");

    data.campaignid = params.get("campaignid");
    data.adgroupid = params.get("adgroupid");
    data.keyword = params.get("keyword");
    data.utm_term = params.get("utm_term");
    data.gad_source = params.get("gad_source");
    data.gad_campaignid = params.get("gad_campaignid");
    data.gbraid = params.get("gbraid");
    data.gclid = params.get("gclid");
    setFormData((prevData) => ({
      ...prevData,
      ...data,
    }));
    handleRecaptchaSubmit();
  };

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, checked } = e.target as HTMLInputElement;
    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  return (
    <div className="sectionke">
      <div className="container-fluid">
        <div className="row banner align-items-center">
          <div
            className="col-lg-6 col-md-12 banner-left"
            style={{ marginLeft: isMobile ? "0.2rem" : "5rem" }}
          >
            <div className="heading">
              <h1 style={{ fontWeight: "400" }}>
                Your Shopify business is losing 30% sales by not being on{" "}
                <span style={{ color: "#25D366" }}>WhatsApp</span>
              </h1>
              <p
                style={{
                  fontSize: "clamp(16px, 5vw, 25px)",
                  fontWeight: "200",
                  marginTop: "40px",
                }}
              >
                Meet your customers where they are — on WhatsApp <br /> and turn
                every interaction into revenue.
              </p>
              <div
                className="flex "
                style={{
                  flexDirection: isMobile ? "column" : "row",
                  gap: isMobile ? "0px" : "1.5rem",
                }}
              >
                {["Recover abandoned carts", "Drive repeat purchases"].map(
                  (text, idx) => (
                    <p key={idx} className="mt-3 second">
                      <img
                        src="/assets/images/keinternational/check.png"
                        alt=""
                      />
                      <span
                        className="mx-2"
                        style={{ fontSize: "clamp(16px, 1vw, 23px)" }}
                      >
                        {text}
                      </span>
                    </p>
                  )
                )}
              </div>
              <div className="flex">
                {["Send back-in-stock reminders"].map((text, idx) => (
                  <p key={idx} className="mt-3 second">
                    <img
                      src="/assets/images/keinternational/check.png"
                      alt=""
                    />
                    <span
                      className="mx-2"
                      style={{ fontSize: "clamp(16px, 1vw, 23px)" }}
                    >
                      {text}
                    </span>
                  </p>
                ))}
              </div>
            </div>
          </div>

          <div
            className="col-lg-5 col-md-12 banner-right mt-4 mt-lg-0"
            style={{ margin: isMobile ? "0 1rem" : "0 0" }}
          >
            <div style={{ marginLeft: "50px" }}>
              <div className="form-wrapper1">
                <div className="form-container1">
                  {successMessage && (
                    <Fade direction="right">
                      <ThankYou name={formData?.name} />
                    </Fade>
                  )}
                  {!successMessage && (
                    <form
                      className="demo-form1"
                      onSubmit={handleSubmit(onSubmit)}
                      noValidate
                    >
                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Full Name"
                      />
                      {errors.name && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.name}
                        </p>
                      )}

                      <div className="col-12">
                        {/* <FloatingLabel controlId="floatingCountry" label="Country*"> */}
                        <Form.Select
                          {...register("country", { required: true })}
                          className={errors?.country ? "is-invalid" : ""}
                          onChange={handleChange}
                          style={{
                            backgroundColor: "#f2f2f2",
                            border: "none",
                            borderRadius: "8px",
                            padding: "14px 16px",
                            fontSize: "14px",
                            width: "100%",
                            color: "#333",
                          }}
                        >
                          <option value="">Select Country</option>
                          {COUNTRIES.map((country) => (
                            <option key={country} value={country}>
                              {country}
                            </option>
                          ))}
                        </Form.Select>
                        {/* {errors?.country && (
                          <Form.Control.Feedback type="invalid">
                            Country is required.
                          </Form.Control.Feedback>
                        )} */}
                        {errors?.country && (
                          <p className="error" style={{ color: "red" }}>
                            {errors.country}
                          </p>
                        )}
                        {/* </FloatingLabel> */}
                      </div>

                      <input
                        type="tel"
                        id="mobile"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Phone Number"
                      />
                      {errors.mobile && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.mobile}
                        </p>
                      )}

                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Email"
                      />
                      {errors.email && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.email}
                        </p>
                      )}

                      <input
                        type="url"
                        id="brand_url"
                        name="brand_url"
                        value={formData.brand_url}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Ecommerce Store link"
                      />
                      {errors.brand_url && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.brand_url}
                        </p>
                      )}

                      {/* <select
                        id="monthly_order"
                        name="monthly_order"
                        value={formData.monthly_order}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        // placeholder="Montly Orders"
                      >
                        <option value="" style={{ color: "#333", }}>Montly Orders</option>
                        {platformOptions.map((opt) => (
                          <option key={opt.name} value={opt.name}>
                            {opt.name}
                          </option>
                        ))}
                      </select>
                      {errors.monthly_order && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.monthly_order}
                        </p>
                      )} */}

                      <div className="col-12 mb-3 check-box-row">
                        <Form.Check // prettier-ignore
                          // {...register("product")}
                          name="emailMarketing"
                          onChange={handleCheckboxChange}
                          checked={formData.emailMarketing}
                          // value="KwikCheckout and RTO"
                          type="checkbox"
                          id="default-checkbox"
                          label="Email marketing — I agree to receive marketing communications by email (such as newsletters, event invitations, special offers, and product updates) from GoExcelsior Private Ltd, a wholly-owned subsidiary of Gokwik. I can unsubscribe at any time by clicking the “Unsubscribe” link in an email."
                          style={{ display: "flex", gap: "10px" }}
                        />
                      </div>

                      <div className="col-12 mb-3 check-box-row">
                        <Form.Check // prettier-ignore
                          // {...register("product")}
                          name="whatsappMarketing"
                          checked={formData.whatsappMarketing}
                          onChange={handleCheckboxChange}
                          // value="KwikCheckout and RTO"
                          type="checkbox"
                          id="default-checkbox"
                          label="WhatsApp marketing — I agree to receive marketing communications via WhatsApp (such as personalised offers, event updates, and product news) from GoExcelsior Private Ltd, a wholly-owned subsidiary of Gokwik. I can opt out at any time by replying STOP on WhatsApp."
                          style={{ display: "flex", gap: "10px" }}
                        />
                      </div>

                      <ReCAPTCHA
                        ref={recaptchaRef as React.RefObject<ReCAPTCHA>}
                        sitekey={RECAPTCHA_SITE_KEY}
                        size="invisible"
                        onChange={handleRecaptchaChange}
                      />

                      <button type="submit" disabled={loading}>
                        {loading ? "Submitting..." : "Book a Demo"}
                      </button>
                      {successMessage && (
                        <p className="success">{successMessage}</p>
                      )}
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SectionOne;
